import { CircularProgress, styled } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useCaseApi } from '../../services/api/useCase.api.ts';
import { Case } from '../../types/Case/Case.type.ts';

const StyledResourcePreview = styled('div')({
  width: '100%',
  height: '100%',
});

interface ResourceDetailsProps {
  caseData?: Case;
  resourceId: number;
}

function ResourceDetails({ caseData, resourceId }: ResourceDetailsProps) {
  const { getCaseResourceById } = useCaseApi();

  const { data: resource, isLoading: resourceLoading } = useQuery({
    queryKey: ['resourceDetails', caseData?.id, resourceId],
    queryFn: () => getCaseResourceById(Number(caseData?.id), resourceId),
    enabled: !!resourceId && !!caseData?.id,
  });

  const pdfUrl = resource?.download_url;

  if (resourceLoading) {
    return (
      <StyledResourcePreview sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </StyledResourcePreview>
    );
  }

  return (
    <StyledResourcePreview>
      <embed
        src={pdfUrl}
        style={{ width: '100%', height: '100%', borderRadius: '8px', border: '1px solid #cbd5e0' }}
        type='application/pdf'
      />
    </StyledResourcePreview>
  );
}

export default ResourceDetails;
